/**
 * @notes: Endpoints for client accounts
 */

export const CLIENT_ENDPOINT = "/clients";
export const WEB_ACCESS_RIGHT_PROFILES_ENDPOINT = "/webAccessRightProfiles";
export const MOBILE_ACCESS_RIGHT_PROFILES_ENDPOINT =
  "/mobileAccessRightProfiles";
